import styled from 'styled-components';

const ErrorWrapper = styled.div`
  width: 100%;
  padding-top: 10px;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    width: 1240px;
    margin: 0 auto;
  }
`;

const StyledH1 = styled.h1`
  color: #161b7a;
`;

const Error500NestedDiv = styled.div`
  overflow: hidden;
  background: #fafafa;
  padding: 10px;
  border: 1px solid #ccc;
`;

export default function Error500() {
  return (
    <ErrorWrapper>
      <section style={{ padding: '0 10px' }}>
        <header>
          <StyledH1>Error 500 : Internal Server Error</StyledH1>
        </header>

        <article>
          <header>
            <h2>Sorry, we seem to have encountered a technical error.</h2>
          </header>
          <p>We have been notified about this.</p>

          <Error500NestedDiv>
            <h4>Please try the following :</h4>
            <ul>
              <li>
                Re-typing the URL in the address bar or clicking the refresh button, as the server
                error may only be temporary.
              </li>
              <li>Try again later.</li>
              <li>
                Visit
                {' '}
                <a href={'http://www.currys.co.uk'}>Currys Homepage</a>
              </li>
              <li>
                Or
                {' '}
                <a href={'http://www.currys.co.uk/faq-list.html'}>Contact Us</a>
              </li>
            </ul>
          </Error500NestedDiv>
        </article>
      </section>
    </ErrorWrapper>
  );
}
